var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomePage = function SvgHomePage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15625_3580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25917 1.59973C8.04446 1.4486 7.78261 1.35987 7.50003 1.35987C7.21749 1.35987 6.95564 1.4486 6.74093 1.59973L1.59025 5.31784C1.23888 5.56517 1.02979 5.96797 1.02979 6.39765V12.3197C1.02979 13.049 1.62099 13.6401 2.35024 13.6401H5.68049V10.9992C5.68049 10.27 6.09958 9.00049 7.50003 9.00049C8.90049 9.00049 9.32049 10.27 9.32049 10.9992V13.6401H12.6498C13.3791 13.6401 13.9703 13.049 13.9703 12.3197V6.39765C13.9703 5.96797 13.7612 5.56517 13.4098 5.31784L8.25917 1.59973Z",
    stroke: "#6B8EFE",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15625_3580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};
export default SvgHomePage;